import { render, staticRenderFns } from "./Penjualan.vue?vue&type=template&id=af14b376&"
import script from "./Penjualan.vue?vue&type=script&lang=js&"
export * from "./Penjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Penjualan.vue"
export default component.exports